import { Component, ElementRef, OnInit, ViewChild, NgZone   } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { EventsService } from '../services/events.service';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { Router } from '@angular/router';
import { CategoriesService } from '../services/categories.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { EncrDecrService } from '../services/encr-decr.service';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { MapsAPILoader } from '@agm/core';
import { AdsService } from '../admin/services/ads.service';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { Validators } from '@angular/forms';


@Component({
  selector: 'app-addevent',
  templateUrl: './addevent.component.html',
  styleUrls: ['./addevent.component.scss']
})
export class AddeventComponent implements OnInit {

  @ViewChild('picker') picker: any;

  clockTheme: NgxMaterialTimepickerTheme = {
    container: {
        bodyBackgroundColor: '#fff',
        buttonColor: '#5d2041',
    },
    dial: {
        dialBackgroundColor: '#5d2041',
    },
    clockFace: {
        clockFaceBackgroundColor: '#5d2041',
        clockHandColor: '#77BB00',
        clockFaceTimeInactiveColor: '#fff'
    }
};

  quillConfig={
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['code-block'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        //[{ 'direction': 'rtl' }],                         // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        //[{ 'font': [] }],
        //[{ 'align': [] }],

        ['clean'],                                         // remove formatting button

        ['link'],
        //['link', 'image', 'video']  
 
      ],
      // handlers: {'emoji': function() {}}
      
    },
    // autoLink: true,

    // mention: {
    //   allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
    //   mentionDenotationChars: ["@", "#"],
    //   source: (searchTerm, renderList, mentionChar) => {
    //     let values;        
    //     if (searchTerm.length === 0) {
    //       renderList(values, searchTerm);
    //     } else {
    //       const matches = [];
    //       for (var i = 0; i < values.length; i++)
    //         if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) matches.push(values[i]);
    //       renderList(matches, searchTerm);
    //     }
    //   },
    // },
    // "emoji-toolbar": true,
    // "emoji-textarea": false,
    // "emoji-shortname": true,
    keyboard: {
      bindings: {
        // shiftEnter: {
        //   key: 13,
        //   shiftKey: true,
        //   handler: (range, context) => {
        //     // Handle shift+enter
        //     console.log("shift+enter")
        //   }
        // },
        enter:{
          key:13,
          handler: (range, context)=>{
            console.log("enter");
            return true;
          }
        }
      }
    }
  }

  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  private geoCoder;
  @ViewChild('search') searchElementRef: ElementRef;
  locationLng:any;
  locationLat:any;
  eventFee:boolean;
  minFee:any = 1;
  maxFee:any = 1;
  formattedaddress=" ";
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: Date;
  public maxDate: Date;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  public disableMinute = false;
  public hideTime = false;
  public recurringEvent = false
  step;
  time = {hour: 0, minute: 0};
  public dateControl = new FormControl(null);


  public placesOptions = {
    componentRestrictions: { country: 'LB' },
    // types: ['geocode']
    };

  public options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ];

  public listColors = ['primary', 'accent', 'warn'];

  public stepHours = [1, 2, 3, 4, 5];
  public stepMinutes = [1, 5, 10, 15, 20, 25];

  public categories = [];


  public coOrganizers: any[] = [{
    email: '',
  }];

  public organizersEmails:any= [];

  public uploader: FileUploader = new FileUploader({});

  eventForm: FormGroup;
  rangeDate: FormGroup;

  adsListUser:[] = []
  adsListAdmin: any = []

  

  constructor(private formBuilder: FormBuilder,
    private eventService: EventsService,
    private EncDecService: EncrDecrService,
    private router: Router,
    private categoriesService: CategoriesService,
    private _snackBar: MatSnackBar,
    private toastr: ToastrService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone, private adsService: AdsService) { }

    

    @ViewChild("placesRef") placesRef : GooglePlaceDirective;

    public handleAddressChange(address: Address) {
      this.eventForm.get('location').setValue(address.formatted_address);
      
  }


  ngOnInit() {

    console.log(this.recurringEvent)
    this.eventForm = this.formBuilder.group({
      EventName: '',
      description: ['', Validators.required],
      isRecurring: '',
      date:'',
      start_time:'',
      locationLat:'',
      locationLng:'',
      end_time:'',
      location: '',
      minFee: 1,
      maxFee: 1,
      website: '',
      img: [null]
    });

    this.rangeDate = this.formBuilder.group({
      start:"",
      end:""
    });

    this.categoriesService.getAllCategories().then((res: any) => {
      for (let i = 0; i < res.categories.length; i++) {
        this.categories.push({
          id: res.categories[i].id,
          name: res.categories[i].name,
          selected: false
        })
      }
      console.log()
    })
      .catch((error) => {

      })

      this.adsService.getAllAdsUser().then((res:any) => {
        this.adsListUser=res.ads.data
        console.log(this.adsListUser)
      })
      this.adsService.getAllAds("123").then((res:any) => {
        for(let i=0;i<res.ads.data.length; i++){
          if(res.ads.data[i].status == 1){
            this.adsListAdmin.push({"ads":res.ads.data[i]})
          }
        }
        console.log(this.adsListAdmin)
      })
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = 1;
        this.longitude = 1;
        this.zoom = 24;
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }
  markerDragEnd($event: any) {
    console.log(JSON.parse(JSON.stringify($event.latLng)).lat);
    this.latitude = JSON.parse(JSON.stringify($event.latLng)).lat;
    this.longitude = JSON.parse(JSON.stringify($event.latLng)).lng;
    this.locationLat = this.latitude
    this.locationLng = this.longitude
    console.log('lat:' + this.latitude)
    this.getAddress(this.latitude, this.longitude);
  }
  searchEnd(){
    setTimeout(() => {
      this.confirmlocation()
    }, 1000);
  }
  confirmlocation(){
    this.locationLat = this.latitude
    this.locationLng = this.longitude  }

  findAdress(){
    this.mapsAPILoader.load().then(() => {
         let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement,this.placesOptions);
         autocomplete.addListener("place_changed", () => {
           this.ngZone.run(() => {
             // some details
             let place: google.maps.places.PlaceResult = autocomplete.getPlace();
             this.address = place.formatted_address;
             this.eventForm.get('location').setValue(this.address);
             //set latitude, longitude and zoom
             this.latitude = place.geometry.location.lat();
             this.longitude = place.geometry.location.lng();
             this.zoom = 12;
           });
         });
       });
   }
  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
          this.address = results[0].formatted_address;
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }
    });
  }
  ngAfterViewInit(){
    this.findAdress()
  }


  freeEventChange()
  {
    if(this.minFee != 0 && this.maxFee != 0)
    {
      this.minFee = 0;
      this.maxFee = 0;

    }
else{
  this.minFee = 1;
  this.maxFee = 1;

}
console.log(this.minFee)
console.log(this.maxFee)
  }


  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }

  // toggleMinDate(evt: any) {
  //   if (evt.checked) {
  //     this._setMinDate();
  //   } else {
  //     this.minDate = null;
  //   }
  // }

  // toggleMaxDate(evt: any) {
  //   console.log(this.minDate)
  //   if (evt.checked) {
  //     this._setMaxDate();
  //   } else {
  //     this.maxDate = null;
  //   }
  // }

  // closePicker() {
  //   this.picker.cancel();
  // }

  // private _setMinDate() {
  //   const now = new Date();
  //   this.minDate = new Date();
  //   this.minDate.setDate(now.getDate() - 1);
  // }


  // private _setMaxDate() {
  //   const now = new Date();
  //   this.maxDate = new Date();
  //   this.maxDate.setDate(now.getDate() + 1);
  // }

  changeSelected($event, category): void {
    category.selected = $event.selected;
  }


  addAddress() {
    this.coOrganizers.push({
      email: '',
    });
    console.log(this.coOrganizers)
  }

  url;
  msg = "";

  selectFile(event) {

    console.log(event.target.files[0])
    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg = 'You must select an image';
      return;
    }

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.msg = "Only images are supported";
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.msg = "";
      this.url = reader.result;
    }

    const file = (event.target as HTMLInputElement).files[0];
    this.eventForm.patchValue({
      img: file
    });
    console.log(file)
    this.eventForm.get('img').updateValueAndValidity();
  }

  addEvent() {
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    let selectedCategories:number[] = [];
    for(let i=0; i<this.categories.length;i++){
      if(this.categories[i].selected)
        selectedCategories.push(this.categories[i].id)
    }
    for(let i=0; i<this.coOrganizers.length; i++){
      if(this.coOrganizers[i].coOrganizers != undefined){
      this.organizersEmails.push(this.coOrganizers[i].coOrganizers)
      }
    }
    this.organizersEmails.push(user.email)

    var formData: FormData = new FormData();

    formData.append("event_name", this.eventForm.get('EventName').value);
    formData.append("organizer_name", user.first_name + ' ' + user.last_name);
    formData.append("organizer_email", this.organizersEmails);
    formData.append("category", selectedCategories+'');
    formData.append("min_fee", this.minFee);
    formData.append("max_fee", this.maxFee);
    formData.append("website", this.eventForm.get('website').value);
    formData.append("description", this.eventForm.get('description').value);
    formData.append("location", this.eventForm.get('location').value);
    formData.append("location_lat", this.eventForm.get('locationLat').value);
    formData.append("location_lng", this.eventForm.get('locationLng').value);
    formData.append("is_recurring", this.eventForm.get('isRecurring').value == '' || this.eventForm.get('isRecurring').value == false ? '0' : '1');
    // formData.append("country", JSON.parse(localStorage.getItem('Selected-Country')).numericCode);
    formData.append("country", "123")
    formData.append("images[]", this.eventForm.get('img').value);

    if(this.eventForm.get('isRecurring').value == '' || this.eventForm.get('isRecurring').value == false || this.eventForm.get('isRecurring').value == undefined)
    {
      const startDate = new Date(this.eventForm.value.date);
      const startTime = this.eventForm.get('start_time').value;
      const endTime = this.eventForm.get('end_time').value;
      formData.append("event_dates[]", JSON.stringify({ "date": startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getDate(), "start_time": startTime, "end_time": endTime }));
    }
    else{
      const startDate = new Date(this.rangeDate.value.start);
      const endDate = new Date(this.rangeDate.value.end);
      const startTime = this.eventForm.get('start_time').value;
      const endTime = this.eventForm.get('end_time').value;
      formData.append("recurring_dates[]", JSON.stringify({ "from_date": startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getDate(), "to_date": endDate.getFullYear() + "-" + (endDate.getMonth() + 1) + "-" + endDate.getDate(), "start_time": startTime, "end_time": endTime }));
    }
    this.eventService.addEvent(formData).then((res: any) => {
      if (res.success) {
        this.eventForm.reset();
        this.url = "";
        this.msg = "";
        this.toastr.success(
          'Your event has been successfully submitted, our team will review your submission and you will be notified accordingly',
          'Event Submitted', {
          timeOut: 6000,
          progressBar: true,
          closeButton: true
        });
      }
      else {
        this._snackBar.open(res.error, '', {
          duration: 5000,
          panelClass: ['error-snackbar'],
          verticalPosition: 'top',

        });
      }
    })
      .catch((error) => {
        console.log(error)
      });
  }

  navigate(url){
    window.open("https://"+url, "_blank")
  }
}
